(function(){
    angular.module('tmx-app').factory('CompanyService', ['tmxResource','$q','lookupService','TMX_FINANCE_CONSTANTS', 
        function(tmxResource,$q,lookupService,TMX_FINANCE_CONSTANTS){


            var Companies = tmxResource("Company");

            Companies.checkCompanyCode=function(companyCode){
             
                return Companies.getById("CheckCompanyCode"+"/"+companyCode)
            };
            Companies.getAllCompanies = function() {

                return Companies.all();
            };

            Companies.getLovs = function(){
             
                return Companies.lov();
            };

            Companies.deleteById = function(id) {
                var deferred = $q.defer();
                Companies.getById(id).then(function(result) {
                    deferred.resolve(result.$remove());
                });
            // item.$remove();
                return deferred.promise;
            };
            Companies.lookup = {};
        // lookupService.getCompanyTypes().then(function (types){
        //     Companies.lookup.type = types;
        //     Companies.recievedLov = true;
        //    // Companies.gridColumn[3].data = types;
        //     Companies.filterColumn[4].data = types;
        // });
        // lookupService.getCompanyClassification().then(function (classes){
        //     Companies.lookup.classification = classes;
        //     //Companies.gridColumn[4].data = classes;
        //     Companies.filterColumn[5].data = classes;
        // });


            Companies.status = [
                { HiddenValue: "active",
                    VisibleValue: "Active"
                },
                { HiddenValue: "inactive",
                    VisibleValue: "Inactive"
                }
            ];
            Companies.filterColumn = [

                {
                    field: "CompanyName",
                    title: "Company Name",
                    type: "alphanumeric",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('CompanyName')}\" >Company Name <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"CompanyName\")' ></i></span>"
                },
                {
                    field: "CompanyCode",
                    title: "Company Code",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('CompanyCode')}\" >Company Code <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"CompanyCode\")' ></i></span>"

                },
                {
                    field: "ContactPersonName",
                    title: "Contact Person",
                    type: "alpha",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('ContactPersonName')}\" >Contact Person <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"ContactPersonName\")' ></i></span>",
                    search: true
                },
                {
                    field: "PhoneNumber1",
                    title: "Contact Phone",
                    type:"numeric",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('PhoneNumber1')}\" >Contact Phone <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"PhoneNumber1\")' ></i></span>",
                    search: true
                },

                {
                    field: "CompanyTypeLkp",
                    title: "Company Type",
                    type: "select",
                    data: Companies.lookup.type,
                    isNumber: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('CompanyTypeLkp')}\" >Company Type <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"CompanyTypeLkp\")' ></i></span>"
                },
                {
                    field: "CompanyClassificationLkp",
                    title: "Company Classification",
                    type: "select",
                    data: Companies.lookup.classification,
                    isNumber: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('CompanyClassificationLkp')}\" >Company Classification <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"CompanyClassificationLkp\")' ></i></span>"
                },

                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    data: Companies.status,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : CompanyCtrl.isFiltered('Status')}\" >Status <i class='fa fa-filter' ng-if='CompanyCtrl.isFiltered(\"Status\")' ></i></span>"
                }

            ];


        //initializing Lookup types from Tmx Finance Constant
            var lkupType = TMX_FINANCE_CONSTANTS.LOOKUP_TYPES;


            var companyTypes=lookupService.getLocalLookupsByType(lkupType.COMPANY_TYPE);
            if(companyTypes){
                Companies.recievedLov = true;
                Companies.lookup.type =companyTypes;
                Companies.filterColumn[4].data = companyTypes;
            }


            var companyClassification=lookupService.getLocalLookupsByType(lkupType.COMPANY_CLASS);
            if(companyClassification){
                Companies.lookup.classification=companyClassification;
                Companies.filterColumn[5].data=companyClassification;
            }

            Companies.columns = angular.copy(Companies.filterColumn);
            Companies.columns.push({field:""});
            return Companies;

        }]);
})();